export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $('.number_slider').slick({
      slidesToShow: 3,
      infinite: false,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
  
      responsive: [  
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.25,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js